export const getEnvironment = (variableEnv: string) => {
  if (process.env[variableEnv] !== undefined && process.env[variableEnv] !== null && process.env[variableEnv] !== '') {
    return process.env[variableEnv];
  } else {
    throw Error('Env is undefined!!!');
  }
};
